
const Index = r => require.ensure([], () => r(require('./Index')), 'v3')
const ReturnMission = r => require.ensure([], () => r(require('./ReturnMission')), 'v3-ReturnMission')
const Task = r => require.ensure([], () => r(require('./Task')), 'v3-Task')
const TaskSchool = r => require.ensure([], () => r(require('./TaskSchool')), 'v3-TaskSchool')
const MakeContract = r => require.ensure([], () => r(require('./MakeContract')), 'v3-MakeContract')
const MakeContractNew = r => require.ensure([], () => r(require('./MakeContractNew')), 'v3-MakeContractNew')
const SchemeDetail = r => require.ensure([], () => r(require('./SchemeDetail')), 'v3-SchemeDetail')
const ShareSchemeDetail = r => require.ensure([], () => r(require('./ShareSchemeDetail')), 'v3-ShareSchemeDetail')
const ShareSchemeDetailNew = r => require.ensure([], () => r(require('./ShareSchemeDetailNew')), 'v3-ShareSchemeDetailNew')
const Invitation = r => require.ensure([], () => r(require('./Invitation')), 'v3-Invitation')
const ConfirmContract = r => require.ensure([], () => r(require('./ConfirmContract')), 'v3-ConfirmContract')
const ReturnMissionDescription = r => require.ensure([], () => r(require('./ReturnMissionDescription')), 'v3-ReturnMissionDescription')
const ResourceDescription = r => require.ensure([], () => r(require('./ResourceDescription')), 'v3-ResourceDescription')
const InputResourceDescription = r => require.ensure([], () => r(require('./InputResourceDescription')), 'v3-InputResourceDescription')
const PCCode = r => require.ensure([], () => r(require('./PCCode')), 'v3-PCCode')
const PartnerAgreement = r => require.ensure([], () => r(require('./PartnerAgreement')), 'v3-PartnerAgreement')
const SoftWareAgreement = r => require.ensure([], () => r(require('./SoftWareAgreement')), 'v3-SoftWareAgreement')
const CommissionExplain = r => require.ensure([], () => r(require('./CommissionExplain')), 'v3-CommissionExplain')
const InvitationFriend = r => require.ensure([], () => r(require('./InvitationFriend')), 'v3-InvitationFriend')
const InvitationNewFriend = r => require.ensure([], () => r(require('./InvitationNewFriend')), 'v3-InvitationNewFriend')
const MoneyStrategy = r => require.ensure([], () => r(require('./MoneyStrategy')), 'v3-MoneyStrategy')
const GoodsDetails = r => require.ensure([], () => r(require('./GoodsDetails')), 'v3-MoneyStrategy')
const NewGoodsDetails = r => require.ensure([], () => r(require('./NewGoodsDetails')), 'v3-MoneyStrategy')
const ActivityPage = r => require.ensure([], () => r(require('./ActivityPage')), 'v3-MoneyStrategy')
const GrabSingleRule = r => require.ensure([], () => r(require('./GrabSingleRule')), 'v3-MoneyStrategy')
const NewUserCenter = r => require.ensure([], () => r(require('./userCenter/NewUserCenter')), 'v213')
const OfficialCounselorrCenter = r => require.ensure([], () => r(require('./OfficialCounselorrCenter')), 'v213')
const Signing = r => require.ensure([], () => r(require('./Signing')), 'Signing')
const Signing5 = r => require.ensure([], () => r(require('./Signing5')), 'Signing5')
const BusinessCooperation = r => require.ensure([], () => r(require('./BusinessCooperation')), 'v214')
const MyPerformance = r => require.ensure([], () => r(require('./MyPerformance')), 'v214')
const MyMorePerformance = r => require.ensure([], () => r(require('./MyMorePerformance')), 'v214')
const FollowUpDetails = r => require.ensure([], () => r(require('./FollowUpDetails')), 'v214')
const MyCommissionDetails = r => require.ensure([], () => r(require('./MyCommissionDetails')), 'v214')
const MyResourcesDetails = r => require.ensure([], () => r(require('./MyResourcesDetails')), 'v214')
const ProjectBonus = r => require.ensure([], () => r(require('./ProjectBonus')), 'v214')
const SpecialLists = r => require.ensure([], () => r(require('./SpecialLists')), 'v230')
const AcademyAward = r => require.ensure([], () => r(require('./AcademyAward')), 'v250')
const AwardRuler = r => require.ensure([], () => r(require('./AwardRuler')), 'v250')
const AwardDetail = r => require.ensure([], () => r(require('./AwardDetail')), 'v250')
const SuccessCaseDetail = r => require.ensure([], () => r(require('./SuccessCaseDetail')), 'v250')
const PowerStatement = r => require.ensure([], () => r(require('./PowerStatement')), 'v250')
const PublishArticleTips = r => require.ensure([], () => r(require('./PublishArticleTips')), 'publishTips')
const PublishVideoTips = r => require.ensure([], () => r(require('./PublishVideoTips')), 'publishTips')
const SchoolLists = r => require.ensure([], () => r(require('./schoolList')), 'schoolList')
const Commission = r => require.ensure([], () => r(require('./Commission')), 'v3')
const SubInfo = r => require.ensure([], () => r(require('./SubInfo')), 'v3')
const Authentication = r => require.ensure([], () => r(require('./Authentication')), 'v3')
const SendStudent = r => require.ensure([], () => r(require('./SendStudent')), 'v3')
const RecommendStudent = r => require.ensure([], () => r(require('./RecommendStudent')), 'v3')
const SignContract = r => require.ensure([], () => r(require('./SignContract')), 'v3')

export default { //
  path: '/v3',
  component: Index,
  children: [
    {
      path: 'business-cooperation',
      name: 'BusinessCooperation',
      component: BusinessCooperation
    },
    {
      path: 'pc-code',
      name: 'PCCode',
      component: PCCode
    },
    {
      // http://0.0.0.0:8080/#/v3/new-user-center?cid=2516&fid=2516&r=8aa61a9ef329586ac5d435eb37a79b33&countryId=12&isApp=false v2.1.3
      meta: {
        title: '个人中心'
      },
      path: 'new-user-center',
      name: 'NewUserCenter',
      component: NewUserCenter
    },
    {
      // http://0.0.0.0:8080/#/v3/official-counselor-center?cid=2516&fid=2516&r=8aa61a9ef329586ac5d435eb37a79b33&countryId=12&isApp=false v2.1.3
      meta: {
        title: '官方顾问中心'
      },
      path: 'official-counselor-center',
      name: 'OfficialCounselorrCenter',
      component: OfficialCounselorrCenter
    },
    {
      // http://0.0.0.0:8080/#/v3/return-mission?taskId=1
      meta: {
        title: '回访任务'
      },
      path: 'return-mission',
      name: 'ReturnMission',
      component: ReturnMission
    },
    {
      // http://0.0.0.0:8080/#/v3/task?taskId=1
      path: 'task',
      name: 'Task',
      meta: {
        title: '制作留学方案任务'
      },
      component: Task
    },
    {
      // http://0.0.0.0:8080/#/v3/task-school?taskId=1
      meta: {
        title: '定校任务'
      },
      path: 'task-school',
      name: 'TaskSchool',
      component: TaskSchool
    },
    {
      // http://0.0.0.0:8080/#/v3/make-contract?resourceId=2022447&pId=123
      path: 'make-contract',
      name: 'MakeContract',
      component: MakeContract,
      meta: {
        title: '制作留学合同'
      }
    },
    {
      // http://0.0.0.0:8080/#/v3/make-contract-new?resourceId=2022447&pId=123
      path: 'make-contract-new',
      name: 'MakeContractNew',
      component: MakeContractNew,
      meta: {
        title: '制作留学合同'
      }
    },
    {
      // http://0.0.0.0:8080/#/v3/scheme-detail?resourceId=2022447&schemeMemberId=0&schemeId=0
      meta: {
        title: '留学规划方案'
      },
      path: 'scheme-detail',
      name: 'SchemeDetail',
      component: SchemeDetail
    },
    {
      // http://0.0.0.0:8080/#/v3/scheme-detail?resourceId=2022447&schemeMemberId=0&schemeId=0
      meta: {
        title: '留学规划方案'
      },
      path: 'share-scheme-detail',
      name: 'ShareSchemeDetail',
      component: ShareSchemeDetail
    },
    {
      // http://0.0.0.0:8080/#/v3/scheme-detail-new?resourceId=2022447&schemeMemberId=0&schemeId=0
      meta: {
        title: '留学规划方案'
      },
      path: 'share-scheme-detail-new',
      name: 'ShareSchemeDetailNew',
      component: ShareSchemeDetailNew
    },
    {
      // http://0.0.0.0:8080/#/v3/Invitation?memberId=1&visitId=1
      meta: {
        title: '邀请函'
      },
      path: 'invitation',
      name: 'Invitation',
      component: Invitation
    },
    {
      // http://0.0.0.0:8080/#/v3/confirm-contract
      meta: {
        title: '确认合同'
      },
      path: 'confirm-contract',
      name: 'ConfirmContract',
      component: ConfirmContract
    },
    {
      // http://0.0.0.0:8080/#/v3/return-mission-description
      meta: {
        title: '小希平台介绍话术'
      },
      path: 'return-mission-description',
      name: 'ReturnMissionDescription',
      component: ReturnMissionDescription
    },
    {
      // http://0.0.0.0:8080/#/v3/resource-description
      meta: {
        title: '什么是自带资源签约'
      },
      path: 'resource-description',
      name: 'ResourceDescription',
      component: ResourceDescription
    },
    {
      // http://0.0.0.0:8080/#/v3/input-resource-description
      meta: {
        title: '什么是录名片'
      },
      path: 'input-resource-description',
      name: 'InputResourceDescription',
      component: InputResourceDescription
    },
    {
      // http://0.0.0.0:8080/#/v3/partner-agreement
      meta: {
        title: '小希-平台合伙人'
      },
      path: 'partner-agreement',
      name: 'PartnerAgreement',
      component: PartnerAgreement
    },
    {
      // http://0.0.0.0:8080/#/v3/soft-ware-agreement
      meta: {
        title: '小希-软件许可及服务协议'
      },
      path: 'soft-ware-agreement',
      name: 'SoftWareAgreement',
      component: SoftWareAgreement
    },
    {
      // http://0.0.0.0:8080/#/v3/commission-explain
      meta: {
        title: '佣金发放说明'
      },
      path: 'commission-explain',
      name: 'CommissionExplain',
      component: CommissionExplain
    },
    {
      // http://0.0.0.0:8080/#/v3/invitation-friend
      meta: {
        title: '推荐有奖'
      },
      path: 'invitation-friend',
      name: 'InvitationFriend',
      component: InvitationFriend
    },
    {
      // http://0.0.0.0:8080/#/v3/invitation-new-friend
      meta: {
        title: '推荐有奖'
      },
      path: 'invitation-new-friend',
      name: 'InvitationNewFriend',
      component: InvitationNewFriend
    },
    {
      // http://0.0.0.0:8080/#/v3/money-strategy
      meta: {
        title: '赚钱攻略'
      },
      path: 'money-strategy',
      name: 'MoneyStrategy',
      component: MoneyStrategy
    },
    {
      // http://0.0.0.0:8080/#/v3/goods-details
      meta: {
        title: ''
      },
      path: 'goods-details',
      name: 'GoodsDetails',
      component: GoodsDetails
    },
    {
      // http://0.0.0.0:8080/#/v3/new-goods-details 2.11版本新商品详情
      meta: {
        title: ''
      },
      path: 'new-goods-details',
      name: 'NewGoodsDetails',
      component: NewGoodsDetails
    },
    {
      // http://0.0.0.0:8080/#/v3/activity-page 2.11版本新商品详情
      meta: {
        title: '抢单模式 上线预告'
      },
      path: 'activity-page',
      name: ' ActivityPage',
      component: ActivityPage
    },
    {
      // http://0.0.0.0:8080/#/v3/grab-single-rule 2.11版本新商品详情
      meta: {
        title: '抢单规则'
      },
      path: 'grab-single-rule',
      name: 'GrabSingleRule',
      component: GrabSingleRule
    },
    {
      // http://0.0.0.0:8080/#/v3/signing 签约实时榜
      meta: {
        title: '签约榜'
      },
      path: 'signing',
      name: 'Signing',
      component: Signing
    },
    {
      // http://0.0.0.0:8080/#/v3/MyPerformance 绩效一级页面
      meta: {
        title: '绩效'
      },
      path: 'my-performance',
      name: 'MyPerformance',
      component: MyPerformance
    },
    {
      // http://0.0.0.0:8080/#/v3/my-more-performance 绩效明细
      meta: {
        title: '绩效明细'
      },
      path: 'my-more-performance/:type',
      name: 'MyMorePerformance',
      component: MyMorePerformance
    },
    {
      // http://0.0.0.0:8080/#/v3/follow-up-details 奖金详情
      meta: {
        title: '更多绩效'
      },
      path: 'follow-up-details',
      name: 'FollowUpDetails',
      component: FollowUpDetails
    },
    {
      // http://0.0.0.0:8080/#/v3/my-commission-details 佣金奖详情
      meta: {
        title: '佣金详情'
      },
      path: 'my-commission-details',
      name: 'MyCommissionDetails',
      component: MyCommissionDetails
    },
    {
      // http://0.0.0.0:8080/#/v3/my-resources-details 资源数明细
      meta: {
        title: '资源详情'
      },
      path: 'my-resources-details',
      name: 'MyResourcesDetails',
      component: MyResourcesDetails
    },
    {
      // http://0.0.0.0:8080/#/v3/project-bonus 单项目奖金明细
      meta: {
        title: '资源详情'
      },
      path: 'project-bonus',
      name: 'ProjectBonus',
      component: ProjectBonus
    },
    {
      // http://0.0.0.0:8080/#/v3/signing5 签约实时榜
      meta: {
        title: '小希顾问五月签约有奖活动'
      },
      path: 'signing5',
      name: 'Signing5',
      component: Signing5
    },
    {
      meta: {
        title: '专题列表'
      },
      path: 'special-lists',
      name: 'SpecialLists',
      component: SpecialLists
    },
    {
      meta: {
        title: '小希各国合作院校-奖励合集'
      },
      path: 'academy-award',
      name: 'AcademyAward',
      component: AcademyAward
    },
    {
      meta: {
        title: '2021小希平台“触手可及”院校奖励政策'
      },
      path: 'award-ruler',
      name: 'AwardRuler',
      component: AwardRuler
    },
    {
      path: 'award-detail',
      name: 'AwardDetail',
      component: AwardDetail
    },
    {
      meta: {
        title: '成功案例详情'
      },
      path: 'success-case-details',
      name: 'SuccessCaseDetail',
      component: SuccessCaseDetail
    },
    {
      meta: {
        title: '说明'
      },
      path: 'power-statement',
      name: 'PowerStatement',
      component: PowerStatement
    },
    {
      meta: {
        title: '如何在小希平台发布文章'
      },
      path: 'publish-article-tips',
      name: 'PublishArticleTips',
      component: PublishArticleTips
    },
    {
      meta: {
        title: '如何在小希平台发布视频'
      },
      path: 'publish-video-tips',
      name: 'PublishVideoTips',
      component: PublishVideoTips
    },
    {
      meta: {
        title: '精通院校'
      },
      path: 'school-lists',
      name: 'SchoolLists',
      component: SchoolLists
    },
    {
      meta: {
        title: '佣金发放规则'
      },
      path: 'commission',
      name: 'Commission',
      component: Commission
    },
    {
      meta: {
        title: '如何递交学生资料'
      },
      path: 'subInfo',
      name: 'SubInfo',
      component: SubInfo
    },
    {
      meta: {
        title: '申请成为平台顾问'
      },
      path: 'authentication',
      name: 'Authentication',
      component: Authentication
    },
    {
      meta: {
        title: '代理送生说明'
      },
      path: 'send-student',
      name: 'SendStudent',
      component: SendStudent
    },
    {
      meta: {
        title: '推荐学生说明'
      },
      path: 'recommend-student',
      name: 'RecommendStudent',
      component: RecommendStudent
    },
    {
      meta: {
        title: '签约说明'
      },
      path: 'sign-contract',
      name: 'SignContract',
      component: SignContract
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/v3/router.js